module.exports = __webpack_public_path__ + "images/vanthart_small4dbc52997aeb0c78148a4e6ec59a0675.png";